import React, { useState } from "react";
import { logOut, signIn } from "../../redux/actions/auth";
import { useDispatch } from "react-redux";
import InputPrimary from "../../components/input/InputPrimary";
import ButtonSecondary from "../../components/buttons/ButtonSecondary";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import bgImg from "../../media/images/login-bg.webp";
import { COMPANY_DOMAIN, COMPANY_NAME, HOSTNAME } from "../../config/constants";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { setnotification } from "../../redux/actions/styles";
import { emailValidation, passwordValidation } from "../../functions/validations";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../config/firebaseConfig";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

const switchUsers = [
  {
    name: "Outlet 1",
    img: bgImg,
  },
  {
    name: "Outlet 2",
    img: bgImg,
  },
  {
    name: "Outlet 3",
    img: bgImg,
  },
];

const Login = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated } = useSelector((state) => state.auth);
  const [userData, setuserData] = useState({
    img: bgImg,
    name: "Tina",
    email: "",
    password: "",
  });

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [loading, setloading] = useState(false);

  const [error, seterror] = useState("");
  const [popupActive, setpopupActive] = useState("admin");

  function onChange(e) {
    seterror("");
    setuserData({ ...userData, [e.target.name]: e.target.value });
  }

  // function onSubmitLogin(e) {
  //   e.preventDefault();

  //   dispatch(signIn(userData, seterror));
  // }

  async function signInUser(userData) {
    if (userData.domain !== HOSTNAME) {
      //  await signOut(auth);
      dispatch(logOut());
      dispatch(setnotification({ visible: true, text: "You are not authorized to this restaurant.", type: "error" }));
      return;
    }

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const token = await user.getIdToken();

    dispatch(setnotification({ visible: true, text: "You are successfully signed in.", type: "success" }));

    dispatch(
      signIn({
        user,
        userData,
      })
    );
    // navigate("/");
  }

  async function onSubmitForm(e) {
    e.preventDefault();

    if (!emailValidation(email) || !passwordValidation(password)) {
      dispatch(setnotification({ visible: true, text: "Enter valid credentials", type: "info" }));
      return;
    }

    setloading(true);

    try {
      const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
      const userIdRef = doc(userAccountsRef, "accounts", email);

      const accounDocSnapshot = await getDoc(userIdRef);

      if (accounDocSnapshot.exists()) {
        const data = accounDocSnapshot.data();

        await signInUser(data);
      } else {
        const clientsDocRef = doc(db, "clients", email);
        const clientDocSnap = await getDoc(clientsDocRef);

        if (clientDocSnap.exists()) {
          const data = clientDocSnap.data();
          await signInUser(data);
        } else {
          dispatch(setnotification({ visible: true, text: "User does not exists.", type: "error" }));
        }
      }
    } catch (error) {
      // ...
      const errorCode = error.code;
      const errorMessage = error.message;

      console.log(errorCode);

      // The email of the user's account used.
      // const email = error.customData.email;
      // The AuthCredential type that was used.

      if (errorCode === "auth/user-disabled") {
        dispatch(
          setnotification({
            visible: true,
            text: "Your account has been disabled, contact us to enable account.",
            type: "error",
          })
        );
      } else {
        dispatch(
          setnotification({
            visible: true,
            text: "Invalid credentials.",
            type: "error",
          })
        );
      }
    }
    setloading(false);
  }

  if (isAuthenticated) {
    return <Navigate replace to="/" />;
  }

  return (
    <div className="login">
      <div className="bg-img">
        <img src={bgImg} alt="background" />
      </div>
      <div className="login-navbar">
        {/* {!isAdmin && <ButtonSecondary className="mr-3" text="Switch User" onClick={() => setpopupActive("switch")} />} */}
        {/* <ButtonPrimary variant="h-primary" size="sm" text="Contact Support" link="mailto:softwarestudiopro@gmail.com" /> */}
      </div>
      {popupActive === "unlock" && (
        <div className="unlock-card">
          <img src={userData.img} alt="user" />
          <form onSubmit={() => {}}>
            <h3>{userData.name}</h3>
            {/* <InputPrimary type="text" label="Username" name="email" value={userData.email} onChange={onChange} /> */}
            <InputPrimary
              type="password"
              label="Password"
              name="password"
              value={userData.password}
              onChange={onChange}
              error={error}
              onFocus={() => seterror("")}
            />
            <div className="action">
              <ButtonPrimary text="Log In" />
            </div>
          </form>
        </div>
      )}

      {popupActive === "switch" && (
        <div className="switch-user">
          <h3>Switch User</h3>
          <div className="scroll-area">
            {switchUsers.map((item, i) => (
              <div
                key={i}
                className="list"
                onClick={() => {
                  setuserData({ ...userData, img: item.img, name: item.name, password: "" });
                  setpopupActive("unlock");
                }}
              >
                <img src={item.img} alt="user" />
                <p>{item.name}</p>
              </div>
            ))}
          </div>

          <p
            className="switch-login"
            onClick={() => {
              setpopupActive("admin");
              setuserData({ ...userData, email: "", password: "" });
            }}
          >
            Admin Login
          </p>
        </div>
      )}

      {popupActive === "admin" && (
        <div className="add-user">
          <form onSubmit={onSubmitForm}>
            <h3 className="mb-4">User Login</h3>
            <InputPrimary
              className="mb-4"
              type="text"
              label="Username"
              name="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              error={error}
              onFocus={() => seterror("")}
            />
            <InputPrimary
              className="mb-5"
              type="password"
              label="Password"
              name="password"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              error={error}
              onFocus={() => seterror("")}
            />
            <div className="action">
              <ButtonPrimary size="sm" className="w-100" text="Log In" onClick={onSubmitForm} loading={loading} />
            </div>
          </form>
        </div>
      )}

      <div className="login-footer">
        <p>
          © {new Date().getFullYear()} –{" "}
          <a href={COMPANY_DOMAIN} target="_blank" rel="noreferrer">
            {COMPANY_NAME}
          </a>
          . All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Login;
